module.exports = __webpack_public_path__ + "static/media/history_15.ac2deb00.jpg";